import { useRef, useEffect, useState } from 'react';
import { makeStyles } from '@ellucian/react-design-system/core';
import { Button, CircularProgress } from '@ellucian/react-design-system/core';

const useStyles = makeStyles({
    name: 'LoadingButton'
})(() => ({
    buttonContent: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    circularProgress: {
        color: 'white',
    }
}));

const LoadingButton = ({ 
    children, 
    isLoading, 
    className,
    isDisabled,
    color = 'primary',
    ...props 
}) => {
    const { classes } = useStyles();
    const buttonRef = useRef(null);
    const [buttonWidth, setButtonWidth] = useState(null);

    useEffect(() => {
        if (buttonRef.current && !buttonWidth) {
            setButtonWidth(buttonRef.current.offsetWidth);
        }
    }, [buttonRef, buttonWidth]);

    return (
        <Button
            ref={buttonRef}
            className={className}
            color={color}
            disabled={isDisabled || isLoading}
            style={{ minWidth: buttonWidth }}
            {...props}
        >
            <div className={classes.buttonContent}>
                {isLoading 
                    ? <CircularProgress size={24} className={classes.circularProgress}/> 
                    : children
                }
            </div>
        </Button>
    );
};

export default LoadingButton;
